import React from "react";

// Hometown's official BBB Accredited Business seal. The PNG is generated by BBB
// with the current rating and "As of" date baked in, so it stays up to date on
// its own — no hardcoded rating/date here. (Same asset the booking library uses.)
const BBB_PROFILE_URL =
    "https://www.bbb.org/us/mi/grand-rapids/profile/dumpster-rentals/hometown-dumpster-rental-0372-90065857/#sealclick";
const BBB_SEAL_IMG =
    "https://seal-westernmichigan.bbb.org/seals/blue-seal-293-61-bbb-90065857.png";

const steps = ["Choose a dumpster", "Schedule delivery", "Pay securely"];

const DumpsterMadeEasyBbb = ({ page }) => (
    <div className={`dumpster-made-easy-bbb${page === "home" ? " dme-home" : ""}`}>
        <div className="container">
            <div className="dme-card">
                <div className="dme-body">
                    <div className="dme-heading">
                        <h3>Dumpster rental made easy</h3>
                        <p>Skip the hassle and book your dumpster in minutes</p>
                    </div>
                    <div className="dme-steps">
                        {steps.map((text, index) => (
                            <div className="dme-step" key={index}>
                                <span className="dme-step-num">{index + 1}</span>
                                <span className="dme-step-text">{text}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="dme-footer">
                    <div className="dme-footer-brand">
                        <span className="dme-brand-name">Hometown Dumpster Rental</span>
                        <span className="dme-brand-sub">Verified A+ Customer Satisfaction</span>
                    </div>
                    <a
                        className="dme-bbb"
                        href={BBB_PROFILE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Hometown Dumpster Rental — BBB Accredited Business profile"
                    >
                        <img
                            src={BBB_SEAL_IMG}
                            alt="Hometown Dumpster Rental BBB Business Review"
                            className="dme-bbb-img"
                            loading="lazy"
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>
);

export default DumpsterMadeEasyBbb;
